import { tracksKeyMap, fsResourceEventMap } from '@didi/webx-js-core';
import { get } from '../request/index';
import { trackEvent } from '../omega/index';
const businessResourceLog = ({ activity, trackType, withFsEvent = false }) => {
    if (!activity || !trackType) {
        return;
    }
    const tracksKey = tracksKeyMap[trackType];
    let tracks = activity[tracksKey] || [];
    tracks.forEach((url) => {
        get(url).catch(() => { });
    });
    if (withFsEvent) {
        const fsResourceEvent = fsResourceEventMap[trackType];
        fsResourceEvent && trackEvent(fsResourceEvent.id, fsResourceEvent.label, activity.log_data);
    }
};
export { businessResourceLog };
